import { render, staticRenderFns } from "./fragment-double-field.vue?vue&type=template&id=2a1dde7c&scoped=true&"
import script from "./fragment-double-field.vue?vue&type=script&lang=js&"
export * from "./fragment-double-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1dde7c",
  null
  
)

export default component.exports